import React, { useContext } from 'react';
import EStyleSheet from 'react-native-extended-stylesheet';
import { View, Text } from 'react-native';
import { width } from '@constants';
import RNPickerSelect from 'react-native-picker-select';
import { AppsRemainingContext } from '@context/AppsRemainingContext';

const minions = [
	// { value: 'gFHx1Agv29WtufvsRIShgjTKoT93', label: 'Michelle Chien' },
	// { value: '9hIaAy4O57XNS3mKpyDMYaa6QME3', label: 'Teera Somsak' },
	// { value: 'r9VeWvPxBSVg8XJ2Yl5W5qLlBnn1', label: 'Tali Benchimol' },
	// { value: 'zxYLhvECAmd7rRLLU4XuFs1GN6H3', label: 'Keren Karshenboym' },
	// { value: 'RuSaPFEXtiMaFZzWcMaBPmfUKXC2', label: 'Lisa Kevitch' },
	// { value: '3daQgHza0MUrDtBC8z3HpRoqMnl2', label: 'Kayla Phillips' },
	// { value: 'P2GDEXRcKwNe12OLJOWzEnSY1Fg1', label: 'Samantha Klein' },
	// { value: 'g8htmHJeTdZjPztNUboTpTLTskT2', label: 'Lexie Evon' },
	// { value: '6wuwy1PMnMX6pFOiyE9zWry8V033', label: 'Olivia Atwood' },
	// { value: 'Sa7vU7UG5WeJXhlCZdhZZFgcQ2C2', label: 'Ian Solow-Niederman' },
	// { value: '0dsob9hWWgdnKOiKcCAeq8AVpfn2', label: 'Sydney M' },
	{ value: 'zRqU1VjlAXOM3O036ZpmhlU2TZS2', label: 'Nancy Goldstein' },
	{ value: 'LT8pwIu4Fihz5FhpAEfvyihaaxO2', label: 'Sabrina Scheinberg' },
];

function FilterByMinion({
	onChange,
	filterByMinionId,
}: {
	onChange: (id: string) => void;
	filterByMinionId: string;
}) {
	const { minionCount } = useContext(AppsRemainingContext);

	return (
		<View style={styles.container}>
			<View>
				<RNPickerSelect
					style={{ inputWeb: styles.inputWeb }}
					placeholder={{ label: 'Sort by minion' }}
					onValueChange={(value) => onChange(value)}
					items={minions}
					value={filterByMinionId}
				/>
				{Boolean(filterByMinionId) && (
					<Text style={styles.count}>
						Apps remaining: <Text style={styles.bold}>{minionCount}</Text>
					</Text>
				)}
			</View>
		</View>
	);
}

const styles = EStyleSheet.create({
	container: {
		width,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 30,
		paddingLeft: 10,
	},
	inputWeb: {
		fontFamily: '$main',
		fontSize: 16,
		color: '$darkBlue',
		paddingVertical: 12,
		borderWidth: 1,
		borderColor: 'gray',
		borderRadius: 4,
	},
	count: {
		marginTop: 5,
		fontFamily: '$main',
		fontSize: 16,
	},
	bold: {
		fontFamily: '$bold',
	},
});

export default FilterByMinion;
